export const INCIDENTS_CHART_BAR_PREFIX = "__bar__";

export type RowSource = "labeler" | "primaryModel" | "secondaryModel";

export type StripeOverlayRect = {
  key: string;
  left: number;
  top: number;
  width: number;
  height: number;
  color: string;
};

const isModelRow = (source: RowSource) => source !== "labeler";

const getHorizontalBarRect = (bar: any) => {
  const vm = bar?._view;
  if (!vm || bar.hidden) {
    return null;
  }

  const left = Math.min(vm.x, vm.base);
  const right = Math.max(vm.x, vm.base);
  const width = right - left;
  if (width <= 0) {
    return null;
  }

  const height = vm.height || 0;
  if (height <= 0) {
    return null;
  }

  return {
    left,
    top: vm.y - height / 2,
    width,
    height,
  };
};

export const collectIncidentsChartStripeOverlays = (
  chart: any
): StripeOverlayRect[] => {
  const datasets: any[] = chart?.data?.datasets || [];
  const rowCount: number = chart?.data?.labels?.length || 0;
  if (rowCount === 0) {
    return [];
  }

  const referenceDataset = datasets.find(
    (dataset) =>
      typeof dataset.label === "string" &&
      dataset.label.indexOf(INCIDENTS_CHART_BAR_PREFIX) === 0 &&
      Array.isArray(dataset._rowSources) &&
      Array.isArray(dataset._rowColors)
  );
  if (!referenceDataset) {
    return [];
  }

  const rowSources: RowSource[] = referenceDataset._rowSources;
  const rowColors: string[] = referenceDataset._rowColors;
  const overlays: StripeOverlayRect[] = [];

  datasets.forEach((dataset, datasetIndex) => {
    if (
      typeof dataset.label !== "string" ||
      dataset.label.indexOf(INCIDENTS_CHART_BAR_PREFIX) !== 0
    ) {
      return;
    }

    const segIdx = dataset.label.slice(INCIDENTS_CHART_BAR_PREFIX.length);
    const meta = chart.getDatasetMeta(datasetIndex);
    if (meta.hidden) {
      return;
    }

    meta.data.forEach((bar: any, rowIndex: number) => {
      if (!isModelRow(rowSources[rowIndex])) {
        return;
      }

      const rect = getHorizontalBarRect(bar);
      if (!rect) {
        return;
      }

      overlays.push({
        key: `${rowIndex}-${segIdx}`,
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        color: rowColors[rowIndex],
      });
    });
  });

  return overlays;
};
